import React from 'react'
import { IconsModel } from './types/iconsModel'

const SvgPhone = ({ color, width = 18, height = 18 }: IconsModel) => (
	<svg width={width} height={height} viewBox="0 0 18 18">
		<path
			d="M14.4 11.625c-.844 0-1.654-.15-2.41-.428-.236-.082-.5-.022-.688.18l-1.485 1.65c-1.91-1.08-3.477-2.812-4.449-4.934l1.486-1.658c.189-.202.242-.495.168-.757-.25-.84-.385-1.74-.385-2.678 0-.413-.303-.75-.674-.75H3.6c-.371 0-.675.337-.675.75 0 7.043 5.137 12.75 11.475 12.75.371 0 .675-.338.675-.75v-2.625c0-.412-.304-.75-.675-.75z"
			transform="translate(-927 -36) translate(369.313 36.5) translate(558) translate(.649)"
			fill={color}
			fillRule="evenodd"
		/>
	</svg>
)

export default SvgPhone